
import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-contract-dialog",
    imports: [MatDialogModule, MatButtonModule],
    templateUrl: "./contract-dialog.component.html",
    styleUrl: "./contract-dialog.component.scss"
})
export class ContractDialogComponent {
  constructor(private ref: MatDialogRef<ContractDialogComponent>) {}

  close() {
    this.ref.close();
  }
  print() {
    window.print();
  }
}
